import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowSpaceBetween: {
        justifyContent: "space-between",
        flexDirection: "row"
    },
    borderedCard: {
        borderRadius: 10
    }
});
export default stylesheet;
